import { useNavigate } from 'react-router-dom'
import { useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { PageContainer } from '../../../../components/page-container/page-container'
import { Pin, type PinHandle } from '../../../../components/pin'
import { Button } from '../../../../components/button'
import { paths } from '../../../../router/paths'
import { type RootState } from '../../../../redux/global-store'
import { userService } from '../../../user/service/user-service'
import { showToast } from '../../../../components/sonner'
import { clearOnboarding } from '../../../../store/user-onboarding'
import { onboardingText, onboardingStyles } from '../styles/onboarding-styles'

export const ConfirmPin = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [pinLocal, setPinLocal] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const onboarding = useSelector((s: RootState) => s.userOnboarding)
  const pinRef = useRef<PinHandle | null>(null)

  const handleChange = (value: string) => {
    const digits = value.replace(/\D/g, '').slice(0, 4)
    setPinLocal(digits)
    if (error) showToast(error, 'error')
  }

  const handleSubmit = async () => {
    if (pinLocal.length !== 4) return
    if (onboarding.pin !== pinLocal) {
      showToast('El PIN no coincide. Intenta nuevamente.', 'error')
      pinRef.current?.clear()
      return
    }
    if (onboarding.dpi === undefined || !onboarding.employeeNumber || !onboarding.agencyId || !onboarding.userInformationId) {
      showToast('Faltan datos de usuario. Reinicie el proceso.', 'error')
      pinRef.current?.clear()
      return
    }
    try {
      setLoading(true)
      await userService.createUserLogin({
        dpi: onboarding.dpi || '',
        employeeNumber: onboarding.employeeNumber,
        agencyId: onboarding.agencyId,
        isFirstAccess: Boolean(onboarding.isFirstAccess),
        userInformationId: onboarding.userInformationId,
        pin: pinLocal,
      })
      {
        dispatch(clearOnboarding())
        navigate(paths.user.concluded)
      }
    } catch (e) {
      showToast('Error al crear el PIN. Intente más tarde.', 'error')
      pinRef.current?.clear()
    } finally {
      setLoading(false)
    }
  }

  return (
    <PageContainer
      type="unauthenticated"
      footerClass='flex w-full flex-col items-center justify-between gap-12 px-8'
      footer={
        <div className="flex w-full flex-col py-12">
          <p className="px-8 pb-6 text-start text-sm font-normal text-[#736969]">
            *Este PIN será su contraseña asociada a su usario para ingresar a
            esta aplicación
          </p>
          {error && (
            <p className="px-8 pb-6 text-start text-sm font-normal text-[red]" role="alert">{error}</p>
          )}
          <div className="flex w-full justify-center">
            <Button
              className="h-[55px] w-full rounded-[10px] text-xl font-semibold"
              onClick={handleSubmit}
              disabled={pinLocal.length !== 4 || !!error}>
              Continuar
            </Button>
          </div>
          <div className="flex w-full justify-center pt-4">
            <Button
              variant="outlined"
              className="h-[55px] w-full rounded-[10px] text-xl font-semibold"
              onClick={() => navigate(paths.user.createPin)}
            >
              Regresar
            </Button>
          </div>
        </div>
      }
    >
      <div className={onboardingStyles.headerBar}>
        <p className={onboardingStyles.headerTitle}>{onboardingText.confirmPin.header}</p>
      </div>
      <div className={onboardingStyles.pageWrapper}>
        <div className={onboardingStyles.section}>
          <p className={onboardingStyles.instruction}>{onboardingText.confirmPin.instruction}</p>
          <div className={onboardingStyles.pinWrapper}>
            <Pin ref={pinRef} onChange={handleChange} type='pin' />
          </div>
        </div>
      </div>

    </PageContainer>
  )
}
